export enum ERefreshPageWarning {
  GENERAL_SETTINGS = 'GENERAL_SETTINGS',
  TICKET_TYPES = 'TICKET_TYPES',
}
